// import React from 'react'

// const ProductDescription = ({ description }) => {
//     return (
//         <div>
//             <div className="ps-document">
//                 <pre >
//                     <p style={{ color: "black", padding: '0px 20px', lineHeight: "18px", textWrap: "initial" }}>
//                         {description}
//                     </p>
//                 </pre>
//             </div> 
//         </div>
//     )
// }

// export default ProductDescription

import React from "react";
import DOMPurify from "dompurify";

const ProductDescription = ({ description }) => {

  // Clean the HTML coming from admin
  const cleanDescription = DOMPurify.sanitize(description || "");

  return (
    <div
      dangerouslySetInnerHTML={{ __html: cleanDescription }}
    />
  );
};

export default ProductDescription;